import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { SectionIntro } from '#src/app/pages/about/shared/components';

import { SupporterTile } from './components/SupporterTile';
import { SUPPORTER_ACTIONS } from './consts';

export const Supporters: React.FC<EmptyProps> = () => {
	return (
		<section className="container flex flex-col gap-10 pb-16 md:gap-14 md:pb-32">
			<SectionIntro
				eyebrow={translationKey('corgi.vision_page.supporters.eyebrow')}
				heading={translationKey('corgi.vision_page.supporters.heading')}
				body={translationKey('corgi.vision_page.supporters.body')}
				align="center"
			/>
			<div className="grid grid-cols-1 gap-3.5 md:grid-cols-2 lg:grid-cols-3" data-qa="vision-supporters-grid">
				{SUPPORTER_ACTIONS.map(({ id, ...action }) => (
					<SupporterTile key={id} {...action} />
				))}
			</div>
		</section>
	);
};
